<template>
	<footer class="container mx-auto py-6 font-bold text-sm">
		<p>&copy; ProxyHeaven {{ new Date().getFullYear() }}. All rights reserved.</p>
	</footer>
</template>
